module.exports = __webpack_public_path__ + "img/openmv.798fa1c9.png";